export default __webpack_public_path__ + "static/media/Gesture icons_Pat-14.649e5db4.svg";